<ng-container *ngIf="action$ | async"></ng-container>

<div *ngIf="data$ | async" class="flex flex-row flex-wrap gap-3">
  <csl-item-card
    [disabled]="disabled"
    (selectClicked)="selectSlot('tc')"
    i18n-title
    title="Верх"
    [iconLink]="getIconLink(panel?.panelOutline?.topSide?.groove?.type)"
    data-testid="topSlot"
    class="top-slot {{ getPlateClass(panel?.panelOutline?.topSide?.groove) }} flex-grow"
    [description]="getDescription(panel?.panelOutline?.topSide?.groove)"
    [cleanable]="!!panel?.panelOutline?.topSide?.groove"
    (cleaned)="delete(panel?.panelOutline.topSide)">
    <div
      *ngIf="isDoubleSidedSlot(panel?.panelOutline?.topSide?.groove)"
      class="mat-caption plate-selector flex flex-row flex-wrap gap-2 items-start">
      <div
        (click)="togglePlate(panel?.panelOutline?.topSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: isBackPlate(panel?.panelOutline?.topSide?.groove) }"
        i18n
        >Обратная</div
      >
      <div
        (click)="togglePlate(panel?.panelOutline?.topSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: !isBackPlate(panel?.panelOutline?.topSide?.groove) }"
        i18n
        >Лицевая</div
      >
    </div>
  </csl-item-card>
  <csl-item-card
    [disabled]="disabled"
    (selectClicked)="selectSlot('bc')"
    [iconLink]="getIconLink(panel?.panelOutline?.bottomSide?.groove?.type)"
    class="bottom-slot {{ getPlateClass(panel?.panelOutline?.bottomSide?.groove) }} flex-grow"
    [description]="getDescription(panel?.panelOutline?.bottomSide?.groove)"
    i18n-title
    title="Низ"
    [cleanable]="!!panel?.panelOutline?.bottomSide?.groove"
    data-testid="bottomSlot"
    (cleaned)="delete(panel?.panelOutline.bottomSide)">
    <div
      *ngIf="isDoubleSidedSlot(panel?.panelOutline?.bottomSide?.groove)"
      class="mat-caption plate-selector flex flex-row flex-wrap gap-2 items-start">
      <div
        (click)="togglePlate(panel?.panelOutline?.bottomSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: isBackPlate(panel?.panelOutline?.bottomSide?.groove) }"
        i18n
        >Обратная</div
      >
      <div
        (click)="togglePlate(panel?.panelOutline?.bottomSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: !isBackPlate(panel?.panelOutline?.bottomSide?.groove) }"
        i18n
        >Лицевая</div
      >
    </div>
  </csl-item-card>
  <csl-item-card
    [disabled]="disabled"
    (selectClicked)="selectSlot('lc')"
    i18n-title
    title="Лево"
    data-testid="leftSlot"
    [iconLink]="getIconLink(panel?.panelOutline?.leftSide?.groove?.type)"
    class="left-slot {{ getPlateClass(panel?.panelOutline?.leftSide?.groove) }} flex-grow"
    [description]="getDescription(panel?.panelOutline?.leftSide?.groove)"
    [cleanable]="!!panel?.panelOutline?.leftSide?.groove"
    (cleaned)="delete(panel?.panelOutline.leftSide)">
    <div
      *ngIf="isDoubleSidedSlot(panel?.panelOutline?.leftSide?.groove)"
      class="mat-caption plate-selector flex flex-row flex-wrap gap-2 items-start">
      <div
        (click)="togglePlate(panel?.panelOutline?.leftSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: isBackPlate(panel?.panelOutline?.leftSide?.groove) }"
        i18n
        >Обратная</div
      >
      <div
        (click)="togglePlate(panel?.panelOutline?.leftSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: !isBackPlate(panel?.panelOutline?.leftSide?.groove) }"
        i18n
        >Лицевая</div
      >
    </div>
  </csl-item-card>
  <csl-item-card
    [disabled]="disabled"
    (selectClicked)="selectSlot('rc')"
    [iconLink]="getIconLink(panel?.panelOutline?.rightSide?.groove?.type)"
    class="right-slot {{ getPlateClass(panel?.panelOutline?.rightSide?.groove) }} flex-grow"
    [description]="getDescription(panel?.panelOutline?.rightSide?.groove)"
    i18n-title
    title="Право"
    [cleanable]="!!panel?.panelOutline?.rightSide?.groove"
    data-testid="rightSlot"
    (cleaned)="delete(panel?.panelOutline.rightSide)">
    <div
      *ngIf="isDoubleSidedSlot(panel?.panelOutline?.rightSide?.groove)"
      class="mat-caption plate-selector flex flex-row flex-wrap gap-2 items-start">
      <div
        (click)="togglePlate(panel?.panelOutline?.rightSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: isBackPlate(panel?.panelOutline?.rightSide?.groove) }"
        i18n
        >Обратная</div
      >
      <div
        (click)="togglePlate(panel?.panelOutline?.rightSide?.groove)"
        class="item"
        [ngClass]="{ disabled: disabled, active: !isBackPlate(panel?.panelOutline?.rightSide?.groove) }"
        i18n
        >Лицевая</div
      >
    </div>
  </csl-item-card>

  <!-- <ng-template [ngTemplateOutlet]="slotCard"
        [ngOutletContext]="{ $implicit: panel?.panelOutline?.topSide?.groove, side: 'tc' }"></ng-template>
    <ng-template [ngTemplateOutlet]="slotCard"
        [ngOutletContext]="{ $implicit: panel?.panelOutline?.bottomSide?.groove, side: 'bc' }"></ng-template>
    <ng-template [ngTemplateOutlet]="slotCard"
        [ngOutletContext]="{ $implicit: panel?.panelOutline?.leftSide?.groove, side: 'lc' }"></ng-template>
    <ng-template [ngTemplateOutlet]="slotCard"
        [ngOutletContext]="{ $implicit: panel?.panelOutline?.rightSide?.groove, side: 'rc' }"></ng-template>

    <ng-template #slotCard let-item let-side="side">
        <csl-item-card [disabled]="disabled" (selectClicked)="selectSlot(side)" i18n-title [title]="'Верх'" [iconLink]="getIconLink(item?.type)" [description]="getDescription(item)" class="flex-grow">

            <div *ngIf="isDoubleSidedSlot(item)" class="mat-caption plate-selector flex flex-row gap-2 items-start">
                <div (click)="togglePlate(item)" class="item"
                    [ngClass]="{'disabled': disabled, 'active': isBackPlate(item)}" i18n>Обратная</div>
                <div (click)="togglePlate(item)" class="item"
                    [ngClass]="{'disabled': disabled, 'active': !isBackPlate(item)}" i18n>Лицевая</div>
            </div>
        </csl-item-card>
    </ng-template> -->
</div>
